import type { CubeMemberInfo } from 'shared/src/trpc-types/cube-load-trpc-types';

export function shortName(ref: string): string {
  const parts = ref.split('.');
  return parts[parts.length - 1];
}

export function memberTitle(ref: string, meta?: Record<string, CubeMemberInfo>): string {
  return meta?.[ref]?.title ?? shortName(ref);
}
